import React, { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useAuth } from './AuthContext';

interface RequireAuthProps {
  children: ReactNode;
}

const RequireAuth: React.FC<RequireAuthProps> = ({ children }) => {
  const { handleLogin, isAuthenticated, isInitialized, isLoggingOut } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (isInitialized && !isAuthenticated && !isLoggingOut) {
      const desiredPath = `${location.pathname}${location.search}${location.hash}`;
      const postAuthRedirectUri = new URL(desiredPath, window.location.origin).toString();
      handleLogin(postAuthRedirectUri);
    }
  }, [handleLogin, isAuthenticated, isInitialized, isLoggingOut, location.hash, location.pathname, location.search]);

  if (!isInitialized || !isAuthenticated) {
    return null;
  }

  return <>{children}</>;
};

export default RequireAuth;
